import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_CONFIG = {
  serviceId: 'service_default', // Replace with your EmailJS service ID
  templateId: 'template_order', // Replace with your EmailJS template ID
  publicKey: 'your_public_key', // Replace with your EmailJS public key
  toEmail: 'ordini@example.com'
};

// Initialize EmailJS (call this in your main component)
export const initEmailJS = () => {
  // EmailJS will work without initialization for basic usage
  // For production, you should set up proper EmailJS account and keys
  console.log('EmailJS initialized for order emails');
};

// Send order email
export const sendOrderEmail = async (orderData) => {
  const { items, totalItems, customerInfo = {} } = orderData;
  
  // Format order items for email
  const formattedItems = items?.map(item => 
    `• ${item?.name} (${item?.sku}) - Quantità: ${item?.quantity}${item?.price ? ` - €${item?.price}` : ''}`
  )?.join('\n') || '';
  
  // Calculate total if prices are available
  const totalAmount = items?.reduce((sum, item) => {
    const price = parseFloat(item?.price || 0);
    const quantity = parseInt(item?.quantity || 0);
    return sum + (price * quantity);
  }, 0);
  
  const emailData = {
    to_email: EMAILJS_CONFIG?.toEmail,
    to_name: 'Sistema Ordini',
    from_name: customerInfo?.name || 'Cliente Online',
    from_email: customerInfo?.email || 'ordine@online.com',
    subject: `Nuovo Ordine - ${new Date()?.toLocaleDateString()}`,
    order_date: new Date()?.toLocaleString('it-IT'),
    total_items: totalItems,
    order_items: formattedItems,
    total_amount: totalAmount > 0 ? `€${totalAmount?.toFixed(2)}` : 'Da calcolare',
    message: `
Dettagli Ordine:
${formattedItems}

Totale articoli: ${totalItems}
${totalAmount > 0 ? `Totale stimato: €${totalAmount?.toFixed(2)}` : ''}

Data ordine: ${new Date()?.toLocaleString('it-IT')}
    `?.trim()
  };
  
  try {
    // For demonstration, we'll use a simple mailto link as fallback
    // In production, replace this with actual EmailJS send
    if (typeof emailjs?.send === 'function' && EMAILJS_CONFIG?.publicKey !== 'your_public_key') {
      const result = await emailjs?.send(
        EMAILJS_CONFIG?.serviceId,
        EMAILJS_CONFIG?.templateId,
        emailData,
        EMAILJS_CONFIG?.publicKey
      );
      return { success: true, messageId: result?.text };
    } else {
      // Fallback: open mailto link
      const subject = encodeURIComponent(emailData?.subject);
      const body = encodeURIComponent(emailData?.message);
      const mailtoUrl = `mailto:${EMAILJS_CONFIG?.toEmail}?subject=${subject}&body=${body}`;
      
      window.open(mailtoUrl, '_blank');
      return { success: true, fallback: true };
    }
  } catch (error) {
    console.error('Email send failed:', error);
    
    // Fallback: open mailto link
    const subject = encodeURIComponent(emailData?.subject);
    const body = encodeURIComponent(emailData?.message);
    const mailtoUrl = `mailto:${EMAILJS_CONFIG?.toEmail}?subject=${subject}&body=${body}`;
    
    window.open(mailtoUrl, '_blank');
    return { success: true, fallback: true, error: error?.message };
  }
};

// Validate email configuration
export const validateEmailConfig = () => {
  const isConfigured = EMAILJS_CONFIG?.serviceId !== 'service_default' && 
                      EMAILJS_CONFIG?.publicKey !== 'your_public_key';
  
  return {
    isConfigured,
    fallbackMode: !isConfigured,
    message: isConfigured ? 
      'EmailJS configurato correttamente' : 'Modalità fallback attiva - verrà aperto il client email'
  };
};
